import { Combobox, Flex, Input, spaceMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledCombobox = styled(Combobox)`
  width: 100%;

  label {
    padding: ${spaceMixin('xs')} !important;
    min-width: 33px;
  }

  svg {
    height: 16px !important;
    width: 16px !important;
  }

  ${(props) =>
    props.$hideDropdown &&
    css`
      section {
        display: none;
      }
    `}

  ${(props) =>
    props.$adjustDropdownHeight &&
    css`
      section {
        ul {
          min-height: 390px;
        }
      }
    `}
`;

export const StyledInput = styled(Input)`
  padding: 9px 0 9px ${spaceMixin('xs')} !important;
  font-weight: 400 !important;
`;

export const StyledSkeletonWrapper = styled(Flex)`
  max-width: 768px;
  margin: 0 auto;
  width: 100%;
  min-height: 80px;
  padding: ${spaceMixin('sm')};
  border-bottom: 1px solid ${token('colors.gray300')};
  display: flex;
  align-items: center;
`;

export const StyledLeadManagementSkeletonWrapper = styled(Flex)`
  display: flex;
  flex: 0.4 0 0;
  align-items: center;
  padding: ${spaceMixin('sm')};
`;
